import UserManagement from 'app/modules/UserManagement';

export default UserManagement;
